'use client';

import {getStaticAssetPath} from '@/lib/utils/assets';
import {Button, Text} from '@eds-web/react';
import {useMessages} from '@epic-mw/i18n';
import {css} from '@panda/css';
import {Box, Grid, GridItem} from '@panda/jsx';
import {usePathname, useRouter} from 'next/navigation';

const errorPageStyle = css({
	background: 'linear-gradient(to bottom, #666 0%, #383838 83%)',
	width: '100%',
	height: '768px',
	display: 'flex',
	justifyContent: 'center',
	alignItems: 'center'
});

const h1Style = css({
	fontSize: '100px !important',
	borderRight: '3px solid white',
	display: 'inline-block',
	lineHeight: '70px !important',
	paddingRight: '10px !important',
	marginBottom: '20px !important',
	textAlign: 'left'
});

const h2Style = css({
	marginLeft: '10px !important',
	marginBottom: '5px !important',
	marginTop: '20px !important',
	fontSize: '27px !important',
	display: 'inline-block',
	lineHeight: '40px !important',
	wordWrap: 'break-word',
	textTransform: 'uppercase',
	textAlign: 'left'
});

const h3Style = css({
	fontSize: '20px !important',
	lineHeight: 1,
	margin: 0,
	marginBottom: '5px !important',
	textAlign: 'left',
	color: 'grey !important'
});

const pStyle = css({
	textAlign: 'left'
});

interface ErrorSectionProps {
	status?: number;
}

export const ErrorSection = function ErrorSection(props: ErrorSectionProps) {
	const {status} = props;
	const pathname = usePathname();
	const router = useRouter();
	const messages = useMessages();

	let error = status || 404;

	if (!error) {
		if (pathname.indexOf('error-500') !== -1 || pathname.indexOf('unexpectedError') !== -1) {
			error = 500;
		} else if (pathname.indexOf('error-404') !== -1) {
			error = 404;
		} else {
			error = 404;
		}
	}

	// useEffect(() => {
	// 	emitEvent({
	// 		eventAction: "error-page",
	// 		eventLabel: error,
	// 		interactionType: "pageView",
	// 	});
	// }, []);

	return (
		<Box id="errorpage" className={errorPageStyle}>
			<Box>
				<Grid gridTemplateColumns="1fr" gap={4} placeItems="center">
					<GridItem>
						<Box
							style={{backgroundImage: `url(${getStaticAssetPath('error-fg.png')})`}} // bgImage prop does not work properly with remote location.
							bgRepeat="no-repeat"
							bgSize="contain"
							maxWidth="500px"
							width="100%"
							aspectRatio={500 / 364}
							display="flex"
							justifyContent="center"
							alignItems="center"
							padding="24px">
							<Box>
								<Text variant="heading3XL" className={h1Style}>
									{error}
								</Text>

								<Text variant="heading2XL" className={h2Style}>
									{messages[`epic.app.error.${error}.title1`]}
									<br />
									{messages[`epic.app.error.${error}.title2`]}
								</Text>

								<Text variant="headingXL" className={h3Style}>
									{messages[`epic.app.error.${error}.msg1`]}
								</Text>

								<Text variant="paragraphLG" className={pStyle}>
									{messages[`epic.app.error.${error}.msg2`]}
								</Text>
							</Box>
						</Box>
					</GridItem>
					<GridItem>
						<Button
							style={{width: '150px'}}
							size="lg"
							onClick={(e) => {
								e.stopPropagation();
								router.push('/');
							}}>
							{messages['epic.app.homePage']}
						</Button>
					</GridItem>
				</Grid>
			</Box>
		</Box>
	);
};
